import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import CommonStructured from "../common-components/CommonStructured";
import { useDispatch, useSelector } from "react-redux";
import { fetchNotificationData } from "../../redux/reducers/apiSlice";
import ReactVortoxSpinner from "../common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../payment-link-system/PaymentLinkTable";
import { selectAuth } from "../auth/auth.selector";
import FilterContainer from "../common-components/filters/filter-container";
import GymFilter from "../common-components/filters/gym-filter";
import DateFilter from "../common-components/filters/date-filter";
import AccountTypeFilter from "../common-components/filters/account-type-filter";
import NotificationTypeFilter from "../common-components/filters/notification-type-filter";
import Modal from "react-modal";
import AddNotification from "./AddNotification";
import { delete_notification } from "../../data/ApiEndpoints";
import { commonPostPutApi } from "../../redux/reducers/commonApiSlice";
import { toast } from "react-toastify";
import { showConfirmAlert } from "../components-react/ReactAlert";
import { notificationColumn } from "./notification-utils";
import { NotificationTabs } from "./NotificationTabs";

const NotificationLanding = () => {
  const dispatch = useDispatch();
  const authData = useSelector(selectAuth);
  const userInfoData = authData?.user;

  const { notificationData, loading } = useSelector((state) => state.api);

  const [isPage, setIsPage] = useState(0);
  const [modalOpen, setModalOpen] = useState(false);
  const [pageLimit, setPageLimit] = useState(10);
  const [notificationType, setNotificationType] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [initialValue, setInitialValue] = useState(null);

  const initialFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    date: "",
    type: "",
    gym_id: "",
    account_type: "",
    notification_status: "",
  };

  useEffect(() => {
    setFilters((prev) => ({
      ...prev,
      page: isPage + 1,
      limit: pageLimit || 10,
    }));
  }, [isPage, pageLimit]);

  const [filters, setFilters] = useState(initialFilters);

  const getNoticationList = () => {
    const apiFilters = {
      ...filters,
      date: filters.date || "",
      gym_id: filters.gym_id?.value || "",
      account_type: filters.account_type?.value || "",
      type: filters.type?.value || "",
    };

    dispatch(
      fetchNotificationData({
        filters: apiFilters,
        token: userInfoData?.token,
      })
    );
  };

  useEffect(() => {
    getNoticationList();
  }, [filters]);

  function onCloseModalvalues() {
    setModalOpen(false);
    setInitialValue(null);
    setIsEdit(false);
  }

  const handleDelete = async (uid) => {
    if (uid) {
      const handleConfirm = async () => {
        try {
          const response = await dispatch(
            commonPostPutApi({
              token: userInfoData?.token,
              endpoint: delete_notification,
              method: "PUT",
              payload: { uid: uid },
            })
          ).unwrap();

          if (response?.status) {
            toast.success(response?.message || "Deleted successfully!");
            getNoticationList();
          } else {
            toast.error(response?.message || "Can not delete!");
          }
        } catch (error) {
          toast.error(error || "Failed to delete");
        }
      };

      showConfirmAlert(handleConfirm, `Are you sure, you want to delete!`);
    } else {
      toast.error("UID required!");
    }
  };

  const handleEdit = (row) => {
    setModalOpen(true);
    setInitialValue(row);
    setNotificationType("push");
    setIsEdit(true);
  };

  const handleReset = () => {
    setFilters(initialFilters);
  };

  const OpenModal = (type) => {
    setModalOpen(true);
    setNotificationType(type);
  };

  const notificationColumns = notificationColumn(
    handleEdit,
    handleDelete,
    filters
  );

  return (
    <Container className="bg-cloud-k px-50px" fluid>
      <Row>
        <Col>
          <CommonStructured
            pageHeading={"Notification"}
            createBtnTxt={"Add Immediate"}
            createBtnTxt1={"Add Schedule"}
            onClickCreateBtn={() => OpenModal("push")}
            onClickCreateBtn1={() => OpenModal("scheduled")}
            isReload={() => getNoticationList()}
          />
        </Col>
      </Row>

      <FilterContainer onReset={handleReset}>
        <GymFilter
          selectedGym={filters?.gym_id}
          setSelectedGym={(value) => {
            setFilters({ ...filters, gym_id: value });
          }}
        />

        <DateFilter
          selectedDate={filters?.date}
          setSelectedDate={(option) => {
            setFilters({ ...filters, date: option });
          }}
        />
        <AccountTypeFilter
          selectedAccountType={filters?.account_type}
          setSelectedAccountType={(option) => {
            setFilters({ ...filters, account_type: option });
          }}
        />
        <NotificationTypeFilter
          selectedNotificationType={filters?.type}
          setSelectedNotificationType={(option) => {
            setFilters({ ...filters, type: option });
          }}
        />
      </FilterContainer>

      <br />
      <NotificationTabs filters={filters} setFilters={setFilters} />

      <div>
        <Modal
          isOpen={modalOpen}
          onRequestClose={onCloseModalvalues}
          contentLabel="Version"
          ariaHideApp={false}
        >
          <AddNotification
            getNoticationList={getNoticationList}
            closeModal={onCloseModalvalues}
            token={userInfoData?.token}
            notificationType={notificationType}
            isEdit={isEdit}
            initialValue={initialValue}
          />
        </Modal>
      </div>

      <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table mt-3">
        {loading ? (
          <ReactVortoxSpinner />
        ) : (
          <PaymentLinkTable
            tableData={
              notificationData?.data?.length > 0 ? notificationData?.data : []
            }
            tableColumns={notificationColumns}
            tablePagination={notificationData?.pagination || {}}
            isPage={isPage}
            setIsPage={(value) => setIsPage(value)}
            setPageLimit={setPageLimit}
            pageLimit={pageLimit}
          />
        )}
      </div>
    </Container>
  );
};

export default NotificationLanding;
